export const environment = {
  production: true,
  apiUrl: 'https://api.sovereignplus.com/api',
  postcodeKey: 'ak_kc4droze4Mupr9XrohIAXQqOoyj03'
};
